import { ReactNode } from 'react';
import classnames from 'classnames';

const className = classnames('flex', 'justify-center', 'items-center', 'px-3');

interface Props {
  children: ReactNode;
}

const ActionListHeader = ({ children }: Props) => (
  <div className={className}>{children}</div>
);

export default ActionListHeader;
